export const NEXT_PUBLIC_TERMS_AND_CONDITIONS_LAST_VERSION =
  process.env.NEXT_PUBLIC_TERMS_AND_CONDITIONS_LAST_VERSION
